import React from 'react';

export const MinusIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="2"
    viewBox="0 0 8 2"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <rect width="8" height="2"/>
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/minus-icon.js